import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89f71618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Search_Contents" }
const _hoisted_2 = { class: "Search_Contents_Title" }
const _hoisted_3 = { class: "Search_Contents_List" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"30px"} }, "～", -1))
const _hoisted_6 = ["value"]

import { ref, watch } from "vue";

// props
interface Props {
  // css調整用----------
  titleMinWidth?: string;
  titleMaxWidth?: string;
  listMinWidth?: string;
  // -------------------
  initialFromData: string; // 初期値(From)
  initialToData: string; // 初期値(To)
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'searchInputDate',
  props: {
    titleMinWidth: {},
    titleMaxWidth: {},
    listMinWidth: {},
    initialFromData: {},
    initialToData: {},
    title: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "58158991": (props.titleMaxWidth !== undefined?props.titleMaxWidth : '90px'),
  "73ff7eed": (props.titleMinWidth !== undefined?props.titleMinWidth : '90px'),
  "fde78a74": (props.listMinWidth !== undefined?props.listMinWidth : '224px')
}))

const props = __props;
// emit
const emit = __emit;

const inputFromValue = ref("" as string);
const inputToValue = ref("" as string);
// 初期値の格納
watch(
  () => props.initialFromData,
  () => {
    if (props.initialFromData !== undefined) {
      inputFromValue.value = props.initialFromData;
    }
  },
  { immediate: true, deep: true }
);
watch(
  () => props.initialToData,
  () => {
    if (props.initialToData !== undefined) {
      inputToValue.value = props.initialToData;
    }
  },
  { immediate: true, deep: true }
);

const chengeFromInput = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) throw new TypeError();
  inputFromValue.value = e.target.value;
  emit("change", inputFromValue.value, inputToValue.value);
};
const chengeToInput = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) throw new TypeError();
  inputToValue.value = e.target.value;
  emit("change", inputFromValue.value, inputToValue.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "date",
        onChange: chengeFromInput,
        value: inputFromValue.value
      }, null, 40, _hoisted_4),
      _hoisted_5,
      _createElementVNode("input", {
        type: "date",
        onChange: chengeToInput,
        value: inputToValue.value
      }, null, 40, _hoisted_6)
    ])
  ]))
}
}

})